import { Profiles } from 'types/user';

export const isReportingPartner = (userProfile: Profiles) =>
  [Profiles.REPORTING_PARTNER, Profiles.REPORTING_PARTNER_WITH_COSTS].includes(userProfile);

export const isNotReportingPartner = (userProfile: Profiles | undefined) =>
  userProfile && !isReportingPartner(userProfile);

export const isAllowedToCostsSection = (userProfile: Profiles | undefined) =>
  userProfile && ![Profiles.REPORTING_PARTNER, Profiles.EXTERNAL].includes(userProfile);
